export const getEmailTemplateStyle = () => ({
  template: {
    fontSize: '16px',
    marginLeft: 0,
    marginTop: 20,
    marginBottom: 0,
  },
  instruction: {
    lineHeight: '24px',
    color: '#323130',
    marginTop: 20,
    marginBottom: 20,
  },
  steps: {
    marginBottom: 12,
  },
  text: {
    marginTop: 15,
    marginBottom: 15,
  },
});

export const emailTemplateWidth = {
  Container: '440px',
  UET: '650px',
};
